module.exports = __webpack_public_path__ + "static/img/image@2x (4).ab5e8740.png";